import { useEffect, useRef, useState } from "react";
import Button from "../../../components/Button";
import { TiArrowRightOutline } from "react-icons/ti";
import { useNavigate } from "react-router-dom";
import Typed from "typed.js";

function HeroSection() {
  const [hovered, setHovered] = useState(false);
  const buttonWidthNormal = 100;
  const buttonWidthIcon = 48;
  const navigate = useNavigate();
  const el = useRef(null);
  const typedInstance = useRef(null);

  useEffect(() => {
    let timeout1, timeout2;

    const options = {
      strings: [
        "Effortless data management powered by AI. Interact with your data using natural language.",
      ],
      typeSpeed: 40,
      backSpeed: 25,
      startDelay: 200,
      showCursor: true,
      cursorChar: "|",
      loop: false,
      onComplete: (self) => {
        timeout1 = setTimeout(() => {
          if (el.current) el.current.textContent = "";
          timeout2 = setTimeout(() => {
            if (el.current) self.reset(true);
          }, 200);
        }, 5000);
      },
    };

    typedInstance.current = new Typed(el.current, options);

    return () => {
      typedInstance.current.destroy();
      clearTimeout(timeout1);
      clearTimeout(timeout2);
    };
  }, []);

  return (
    <div
      className="w-full h-screen bg-cover bg-center relative"
      style={{ backgroundImage: "url('/hero.jpg')" }}
    >
      <div className="absolute top-0 left-0 w-full h-full">
        <img
          src="/back_hero.gif"
          alt="Animated background"
          className="absolute top-0 left-0 w-full h-full object-cover"
          style={{
            pointerEvents: "none",
            zIndex: 5,
            filter: "blur(7px)",
          }}
        />

        <div
          className="absolute top-0 left-0 w-full h-full"
          style={{
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            zIndex: 6,
            pointerEvents: "none",
          }}
        />
      </div>

      <div className="container mx-auto px-6 md:px-8 lg:px-10 relative z-10 flex flex-col items-center justify-center h-full text-center text-white">
        <h1
          className="text-3xl sm:text-5xl font-normal mb-3"
          style={{ fontFamily: "Varino" }}
        >
          managing data by generative aI
        </h1>

        <p
          className="text-sm sm:text-lg mb-6 h-12"
          style={{ width: "80%", maxWidth: "550px", marginBottom: "27px" }}
        >
          <span ref={el} />
        </p>

        <div
          style={{
            height: "42px",
            padding: "6px 15px 6px 6px",
            backgroundColor: "rgba(0,0,0,0.5)",
            borderRadius: "100px",
            display: "flex",
            gap: "10px",
            alignItems: "center",
            position: "relative",
            overflow: "hidden",
            transition: "all 1s ease",
            cursor: "pointer",
          }}
          className="hover-container"
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
          onClick={() => navigate("/register")}
        >
          <div className="inner-item button">
            <Button
              content={
                hovered ? <TiArrowRightOutline size={22} /> : "FREE TRIAL"
              }
              style={{
                width: hovered ? buttonWidthIcon : buttonWidthNormal,
                transition: "width 0.4s ease",
              }}
            />
          </div>

          <div
            className="inner-item text"
            style={{
              color: "var(--color-third)",
              fontFamily: "Lato",
              fontSize: "17px",
              cursor: "pointer",
              transition: "transform 0.8s ease",
            }}
          >
            Get started
          </div>

          <style>
            {`
          .hover-container .inner-item {
            transition: transform 0.8s ease;
          }
          
          .hover-container:hover .button {
            transform: translateX(105px);
          }
          
          .hover-container:hover .text {
            transform: translateX(-50px);
          }
          
          .hover-container:not(:hover) .inner-item {
            transform: translateX(0);
          }
        `}
          </style>
        </div>
      </div>
    </div>
  );
}

export default HeroSection;
